module.exports = __webpack_public_path__ + "1791188489487/images/mastercard.7bbc1c0.png";